import React from "react"
import { ColorPickerSeeker } from "@ui-seeker/core"

import { useUserSettingsSite, useUserSettingsSiteValidator } from "../../../@hooks"
import { userSettingSitesFormData } from "../../../@signals"


export default function UserSettingTierDrawerColor() {
	const { handleChangeSitesFormData } = useUserSettingsSite()
	const { colorError } = useUserSettingsSiteValidator()

    return <ColorPickerSeeker
		value={userSettingSitesFormData.value?.color}
		onChange={newColor => handleChangeSitesFormData(newColor, 'color')}
		label="Color"
		error={colorError}
	/>
}